// extracted by mini-css-extract-plugin
export default {"productRange":"ProductRange_productRange__dm9bI","header":"ProductRange_header__i2mJ6","cards":"ProductRange_cards__v5bEa","card":"ProductRange_card__3X5Hr"};